import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Card, Form } from 'react-bootstrap';
import img from '../../../utils/logo500.png';
import { PencilSquare, TrashFill } from 'react-bootstrap-icons';
import EditProductoTienda from './components/editProductoTienda';
import { useParams } from 'react-router-dom';
import APIserver from '../../../api/axiosConfig';
import Swal from 'sweetalert2'; // Importar SweetAlert

const VerProductoTienda = () => {
    const [showEdit, setShowEdit] = useState(false);
    const [productoTiendaId, setProductoTiendaId] = useState(null); // Estado para almacenar el id del productoTienda
    const [producto, setProducto] = useState(null); // Estado para almacenar el producto
    const [error, setError] = useState(null); // Estado para manejar los errores
    const { referencia } = useParams(); // Obtener la referencia de la URL

    // Estado para almacenar la referencia y la categoría
    const [referenciaState, setReferencia] = useState('');
    const [categoria, setCategoria] = useState({ nomCategoria: '', idCategoria: null }); // Almacenamos tanto el nombre como el id de la categoría

    // Estado para los productos seleccionados
    const [selectedProducts, setSelectedProducts] = useState([]);

    useEffect(() => {
        const fetchProducto = async () => {
            try {
                const response = await APIserver.get(`/api/producto-tienda/${referencia}`);
                console.log('API Response:', response.data); // Para verificar la estructura

                if (response.data && Array.isArray(response.data.productosPorCategoria)) {
                    setProducto({
                        productos: response.data.productosPorCategoria, // Accedemos correctamente a los productos
                    });
                    setError(null);
                } else {
                    console.warn('No se encontró el producto.');
                    setProducto(null);
                    setError('Producto no encontrado');
                }
            } catch (error) {
                console.error('Error al obtener el producto:', error);
                setProducto(null);
                setError(error.response?.status === 404 ? 'Producto no encontrado' : 'Ocurrió un error al obtener el producto.');
            }
        };

        if (referencia) {
            fetchProducto();
        }
    }, [referencia]);

    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (idProductoTienda) => {
        const selectedProduct = producto.productos.find(item => item.idProductoTienda === idProductoTienda);

        if (selectedProduct) {
            setReferencia(`${selectedProduct.referencia} - ${selectedProduct.nomProducto}`);

            setCategoria(selectedProduct.categorias?.map((idCategoria, index) => ({
                value: idCategoria,
                label: selectedProduct.nombresCategorias[index]
            })) || []);

            setProductoTiendaId(idProductoTienda);
            setShowEdit(true);
        } else {
            console.log('Producto no encontrado.');
        }
    };

    // Función para manejar la selección y deselección de productos
    const handleSelectProduct = (idProductoTienda) => {
        setSelectedProducts((prevSelected) => {
            if (prevSelected.includes(idProductoTienda)) {
                // Si el producto ya está seleccionado, lo desmarcamos
                return prevSelected.filter(id => id !== idProductoTienda);
            } else {
                // Si el producto no está seleccionado, lo agregamos
                return [...prevSelected, idProductoTienda];
            }
        });
    };

    // Función para eliminar productos seleccionados con confirmación
    const handleDeleteSelected = async () => {
        if (selectedProducts.length === 0) {
            Swal.fire('Atención', 'No has seleccionado ningún producto.', 'info');
            return;
        }

        // Confirmar eliminación
        const confirmation = await Swal.fire({
            title: '¿Estás seguro?',
            text: `¿Deseas eliminar ${selectedProducts.length} producto(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (confirmation.isConfirmed) {
            try {
                const response = await APIserver.delete('/api/productos-tienda-eliminar', {
                    data: { ids: selectedProducts }
                });

                if (response.status === 200) {
                    // Filtrar productos eliminados del estado
                    setProducto(prevProducto => ({
                        ...prevProducto,
                        productos: prevProducto.productos.filter(producto =>
                            !selectedProducts.includes(producto.idProductoTienda)
                        ),
                    }));

                    // Limpiar la selección
                    setSelectedProducts([]);

                    // Mostrar alerta de éxito
                    Swal.fire('Eliminados', `Se eliminaron ${selectedProducts.length} producto(s) correctamente.`, 'success');
                }
            } catch (error) {
                console.error('Error al eliminar productos:', error);
                Swal.fire('Error', 'Ocurrió un error al eliminar los productos.', 'error');
            }
        }
    };

    // Función para eliminar un solo producto con confirmación
    const handleDeleteProduct = async (idProductoTienda) => {
        const confirmation = await Swal.fire({
            title: '¿Estás seguro?',
            text: '¿Deseas eliminar este producto?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });

        if (confirmation.isConfirmed) {
            try {
                const response = await APIserver.delete('/api/productos-tienda-eliminar', {
                    data: { ids: [idProductoTienda] }
                });

                if (response.status === 200) {
                    // Filtrar el producto eliminado del estado
                    setProducto(prevProducto => ({
                        ...prevProducto,
                        productos: prevProducto.productos.filter(producto =>
                            producto.idProductoTienda !== idProductoTienda
                        ),
                    }));

                    // Mostrar alerta de éxito
                    Swal.fire('Eliminado', 'El producto fue eliminado correctamente.', 'success');
                }
            } catch (error) {
                console.error('Error al eliminar el producto:', error);
                Swal.fire('Error', 'Ocurrió un error al eliminar el producto.', 'error');
            }
        }
    };

    if (error) {
        return <div>{error}</div>; // Muestra el mensaje de error si existe
    }

    if (!producto) {
        return <div>Cargando...</div>; // Muestra un mensaje mientras carga el producto
    }

    return (
        <>
            <div className='mx-2 mt-3'>
                <div className='d-flex flex-column flex-md-row align-items-center justify-content-between'>
                    <p className="mb-2 mb-md-0">
                        Administra las imágenes organizadas por categoría que muestras en el Catalogo.
                    </p>
                    {selectedProducts.length > 1 && (
                        <div className='d-flex mt-2 mt-md-0'>
                            <Button
                                variant='danger'
                                className='d-flex align-items-center me-2 shadow-sm'
                                onClick={handleDeleteSelected}
                            >
                                <TrashFill className='me-2' /> Eliminar Productos seleccionados
                            </Button>
                        </div>
                    )}
                </div>

                {producto?.productos?.length > 0 ? (
                    Object.entries(
                        producto.productos.reduce((acc, item) => {
                            item.categorias.forEach((idCategoria, index) => {
                                const nomCategoria = item.nombresCategorias[index];

                                if (!acc[idCategoria]) {
                                    acc[idCategoria] = { idCategoria, nomCategoria, productos: [] };
                                }

                                acc[idCategoria].productos.push(item);
                            });

                            return acc;
                        }, {})
                    ).map(([idCategoria, categoria]) => (
                        <div key={idCategoria}>
                            <h3 className="mt-4">{categoria.nomCategoria}</h3>
                            <div className="row">
                                {categoria.productos.map((item, index) => (
                                    <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 p-2 my-4">
                                        <Card className="h-100">
                                            <div style={{ position: 'relative' }}>
                                                <Card.Img
                                                    variant='top'
                                                    src={item.imgProducto || img}
                                                    alt='img'
                                                />
                                                <div style={{
                                                    position: 'absolute',
                                                    top: '10px',
                                                    right: '10px',
                                                    cursor: 'pointer',
                                                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                                    borderRadius: '50%',
                                                    padding: '5px'
                                                }}>
                                                    <Form>
                                                        <Form.Check
                                                            type='checkbox'
                                                            id={`select-${item.idProductoTienda}`}
                                                            aria-label={`checkbox-${item.idProductoTienda}`}
                                                            checked={selectedProducts.includes(item.idProductoTienda)}
                                                            onChange={() => handleSelectProduct(item.idProductoTienda)}
                                                        />
                                                    </Form>
                                                </div>
                                            </div>
                                            <Card.Body className='text-center'>
                                                <ButtonGroup aria-label="Buttons-actions" className='m-2 mt-3'>
                                                    <Button variant='warning' onClick={() => handleShowEdit(item.idProductoTienda)}>
                                                        <PencilSquare />
                                                    </Button>
                                                    <Button variant='danger' onClick={() => handleDeleteProduct(item.idProductoTienda)}>
                                                        <TrashFill />
                                                    </Button>
                                                </ButtonGroup>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No hay productos disponibles.</p>
                )}

            </div>
            <EditProductoTienda
                showEdit={showEdit}
                handleCloseEdit={handleCloseEdit}
                productoTiendaId={productoTiendaId}
                producto={producto}
                referencia={referenciaState}
                categoria={categoria} // Ahora pasamos tanto el nombre como el id de la categoría
            />
        </>
    );
};

export default VerProductoTienda;
